const raspberry1 = {
    name: "Raspberry Pi 1",
    paths: {
        "int./": null,
        "int.*": {
            phases: [
                {
                    label: "Fe1",
                    role: "IF",
                    input: null,
                    output: "Fe1/Fe2",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Fe2",
                    role: "IF",
                    input: "Fe1/Fe2",
                    output: "Fe2/De",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "De",
                    role: "ID",
                    input: "Fe2/De",
                    output: "De/Iss",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Iss",
                    role: "ID",
                    input: "De/Iss",
                    output: "Iss/MUL1",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "MUL1",
                    role: "EX",
                    input: "Iss/MUL1",
                    output: "MUL1/MUL2",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "MUL2",
                    role: "EX",
                    input: "MUL1/MUL2",
                    output: "MUL2/MUL3",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "MUL3",
                    role: "EX",
                    input: "MUL2/MUL3",
                    output: "*/WBex",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "WBex",
                    role: "WB",
                    input: "*/WBex",
                    output: null,
                    latency: 1,
                    canDelay: false
                }          
            ],
            opARequired: "MUL1",
            opBRequired: "MUL1",
            targetProvided: "MUL3",
            registerWriteBack: "WBex",
            registerReadOut: "Iss"
        },
        "int*": {
            phases: [
                {
                    label: "Fe1",
                    role: "IF",
                    input: null,
                    output: "Fe1/Fe2",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Fe2",
                    role: "IF",
                    input: "Fe1/Fe2",
                    output: "Fe2/De",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "De",
                    role: "ID",
                    input: "Fe2/De",
                    output: "De/Iss",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Iss",
                    role: "ID",
                    input: "De/Iss",
                    output: "Iss/Sh",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Sh",
                    role: "EX",
                    input: "Iss/Sh",
                    output: "Sh/ALU",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "ALU",
                    role: "EX",
                    input: "Sh/ALU",
                    output: "ALU/Sat",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "Sat",
                    role: "EX",
                    input: "ALU/Sat",
                    output: "*/WBex",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "WBex",
                    role: "WB",
                    input: "*/WBex",
                    output: null,
                    latency: 1,
                    canDelay: false
                }          
            ],
            opARequired: "Sh",
            opBRequired: "Sh",
            targetProvided: "Sat",
            registerWriteBack: "WBex",
            registerReadOut: "Iss"
        },
        "mem*": {
            phases: [
                {
                    label: "Fe1",
                    role: "IF",
                    input: null,
                    output: "Fe1/Fe2",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Fe2",
                    role: "IF",
                    input: "Fe1/Fe2",
                    output: "Fe2/De",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "De",
                    role: "ID",
                    input: "Fe2/De",
                    output: "De/Iss",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Iss",
                    role: "ID",
                    input: "De/Iss",
                    output: "Iss/Sh",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "ADD",
                    role: "EX",
                    input: "Iss/ADD",
                    output: "ADD/DC1",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "DC1",
                    role: "MEM",
                    input: "ADD/DC1",
                    output: "DC1/DC2",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "DC2",
                    role: "MEM",
                    input: "DC1/DC2",
                    output: "DC2/WBls",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "WBls",
                    role: "WB",
                    input: "DC2/WBls",
                    output: null,
                    latency: 1,
                    canDelay: false
                }          
            ],
            opARequired: "ADD",
            opBRequired: "DC1",
            targetProvided: "DC2",
            registerWriteBack: "WBls",
            registerReadOut: "Iss"
        },
        "jump*": {
            phases: [
                {
                    label: "Fe1",
                    role: "IF",
                    input: null,
                    output: "Fe1/Fe2",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Fe2",
                    role: "IF",
                    input: "Fe1/Fe2",
                    output: "Fe2/De",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "De",
                    role: "ID",
                    input: "Fe2/De",
                    output: "De/Iss",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Iss",
                    role: "ID",
                    input: "De/Iss",
                    output: "Iss/Sh",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "Sh",
                    role: "EX",
                    input: "Iss/Sh",
                    output: "Sh/ALU",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "ALU",
                    role: "EX",
                    input: "Sh/ALU",
                    output: "ALU/Sat",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "Sat",
                    role: "EX",
                    input: "ALU/Sat",
                    output: "*/WBex",
                    latency: 1,
                    canDelay: false
                },
                {
                    label: "WBex",
                    role: "WB",
                    input: "*/WBex",
                    output: null,
                    latency: 1,
                    canDelay: false
                }          
            ],
            opARequired: "",
            opBRequired: "EX",
            targetProvided: "",
            registerWriteBack: "",
            registerReadOut: "ID"         
        }
    },
    description: "Ez lenne a Raspberry Pi 1. változatában dolgozó CPU utasítás pipeline-ja. Az Fe1 hívja le az utasítást, "
        +"az Fe2 végzi az elágazásbecslést, a De dekódol, az Iss betölti a regiszter operandusok értékét a regisztertárolóból. "
        +"Ezt követően 3 lehetőség adódik: az aritmetikai és logikai utasítások végrehajátása három fázisú: az Sh végrehajt egy "
        +"operandus shiftelést (erre az ARM utasításkészlet lehetőséget ad), megörténik a művelet, végül a Sat érvényesíti a "
        +"telítődő aritmetikát (szintén ARM jellegzetesség). Az egész szorzás szintén 3 fázisú, de itt nincs sem shift, sem telítődés."
        +"A valódi pipeline-ban az ALU és a szorzó nem mehet egyszerre, de ettől a kényszertől most tekintsünk el. A memóriaműveletek "
        +"szintén 3 fázisúak, az ADD címet számol, a DC1 és DC2 pedig az adatcache elérését végzi. "
        +"A pipeline minden fázisa képes utasítást várakoztatni, minden forwarding út használata megengedett."
};

export default raspberry1;